// extracted by mini-css-extract-plugin
export default {"wrapper":"_54fb548b","fullWidthWrapper":"_13a8d03e","innerWrapper":"_e9e67d15","fullWidthInnerWrapper":"_7f9d3160","link":"_396ca5f8","specify":"_f4e2ebcb"};